<p-toast></p-toast>
<p-toolbar>
  <ng-template pTemplate="left">
    <button pButton pRipple label="Новий запис" icon="pi pi-plus" class="p-button-success mr-2" [disabled]="editMode" (click)="addBlockedCounterparty()"></button>
  </ng-template>
  <ng-template pTemplate="right">
    <span class="p-input-icon-left mr-2">
      <i class="pi pi-search"></i>
      <input pInputText type="text" [(ngModel)]="blockedCounterpartiesGlobalFilter"
             (input)="blockCounterpartiesTable.filterGlobal($event.target.value, 'contains')"
             placeholder="Пошук за всіма полями..." />
    </span>
    <p-button icon="pi pi-refresh" label="Оновити" (onClick)="reloadTable()" [disabled]="editMode"
              pTooltip="Оновити список" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>

<p-table #blockCounterpartiesTable
         [value]="blockedCounterparties"
         [globalFilterFields]="['counterparty_iban','counterparty_edrpou','description']"
         [rowHover]="true"
         [resizableColumns]="true"
         editMode="row"
         dataKey="uid"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
  <ng-template pTemplate="header">
    <tr>
      <th style="width:6rem"></th>
      <th width="25%">IBAN контрагента</th>
      <th width="25%">EDRPOU контрагента</th>
      <th width="25%">Опис</th>
      <th width="10%" style="text-align: center">Активний</th>
      <th width="10%">Додано</th>
      <th style="width:6rem"></th>
    </tr>
    <tr>
      <th></th>
      <th>
        <input pInputText type="text" (input)="blockCounterpartiesTable.filter($event.target.value, 'counterparty_iban', 'contains')"
               placeholder="Пошук" class="p-column-filter" style="width:100%">
      </th>
      <th>
        <input pInputText type="text" (input)="blockCounterpartiesTable.filter($event.target.value, 'counterparty_edrpou', 'contains')"
               placeholder="Пошук" class="p-column-filter" style="width:100%">
      </th>
      <th>
        <input pInputText type="text" (input)="blockCounterpartiesTable.filter($event.target.value, 'description', 'contains')"
               placeholder="Пошук" class="p-column-filter" style="width:100%">
      </th>
      <th></th>
      <th></th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="row">
      <td>
        <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(row)" class="p-button-rounded p-button-text"></button>
        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(row)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(row, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="row.counterparty_iban" style="width:100%"></ng-template>
          <ng-template pTemplate="output">{{row.counterparty_iban}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="row.counterparty_edrpou" style="width:100%"></ng-template>
          <ng-template pTemplate="output">{{row.counterparty_edrpou}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="row.description" style="width:100%"></ng-template>
          <ng-template pTemplate="output">{{row.description}}</ng-template>
        </p-cellEditor>
      </td>
      <td style="text-align: center">
        <p-inputSwitch [(ngModel)]="row.active" [disabled]="editing" (onChange)="toggleActive(row, $event.checked)"></p-inputSwitch>
      </td>
      <td>{{row.added_at | date:'dd.MM.yyyy'}}</td>
      <td></td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr><td colspan="7">Немає заблокованих контрагентів</td></tr>
  </ng-template>
</p-table>
